export const normalizePhoneNumber = (phoneNumber) => phoneNumber.replace(/ /g, '')

export const prettifyPhoneNumber = (phoneNumber) => {
  const normalized = normalizePhoneNumber(phoneNumber)

  // correct number has 12 chars (+48456789012) -> then .match will split it per 3
  return normalized.length === 12 ? normalized.match(/.{1,3}/g).join(' ') : phoneNumber
}
